import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import ConfirmCancel from './confirm-cancel';
import { v4 as uuidv4 } from 'uuid';

import * as ProjectActionType from 'Projects/constants';

import delete_icon from 'assets/img/delete.svg';

class TemplateEPLAdd extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    getDefaultTemplate: PropTypes.func,
    builderName: PropTypes.string,
    dispatch: PropTypes.func,
    projectId: PropTypes.string
  };

  constructor(props) {
    super(props);

    const defaultDisclaimer =
    '**A checked box signals a completed/acceptable item. An unchecked box signals the item is not complete and a work order has been opened.** and are listed under “The following items require attention”. And have been sent to the General Contractor or its trades.\n\n1. That all commitments are in writing on these forms. No verbal commitments have been made.\n\n2. A unit inspection has been completed for the areas checked above and is accepted subject to the work orders being completed as enclosed in this document. Any unforeseen non-functioning workmanship may not have been found and will be treated as warranty.';

    this.state = {
      openCustomTemplate: false,
      openEditTemplate: false,
      checked: false,
      editTitle: false,
      customTemplate: {
        name: 'Untitled template',
        sections: [],
        disclaimer: defaultDisclaimer
      },
      titleConfig: {
        field1: { enabled: false, value: '' },
        field2: { enabled: false, value: '' },
        field3: { enabled: false, value: '' }
      },
      openConfirmCancelModal: false,
      openModalConfirm: false
    };
  }

  createTemplate = () => {
    const { customTemplate, titleConfig } = this.state;
    let submittedSections = customTemplate.sections.map(section => {
      return {
        name: section.title,
        items: section.items.filter(item => item.content !== null && item.content.length > 0).map(item => item.content)
      };
    });

    const params = {
      projectId: this.props.projectId,
      name: this.state.customTemplate.name,
      disclaimer: this.state.customTemplate.disclaimer,
      sections: submittedSections,
      IsCheckedTitle1: titleConfig.field1.enabled,
      IsCheckedTitle2: titleConfig.field2.enabled,
      IsCheckedTitle3: titleConfig.field3.enabled
    };

    if (titleConfig.field1.enabled && titleConfig.field1.value) {
      params.Title1 = titleConfig.field1.value;
    }
    if (titleConfig.field2.enabled && titleConfig.field2.value) {
      params.Title2 = titleConfig.field2.value;
    }
    if (titleConfig.field3.enabled && titleConfig.field3.value) {
      params.Title3 = titleConfig.field3.value;
    }

    this.setState({ customTemplate: {...customTemplate, sections: submittedSections }}, () => {
      this.props.dispatch({
        type: ProjectActionType.CREATE_NEW_PROJECT_EPL_TEMPLATE_ASYNC,
        params: params,
        callback: this.onCloseAndGetList
      });
    });
  }

  onCloseAndGetList = () => {
    this.props.onClose();
    this.props.getDefaultTemplate();
  }

  onCancelConfirmModal = () => {
    this.setState({
      openModalConfirm: !this.state.openModalConfirm,
      openConfirmCancelModal: false
    });
  }

  isInvalidTemplate() {
    const { customTemplate } = this.state;

    if (customTemplate.sections.length === 0) {
      return true;
    }

    if (customTemplate.sections.some(s => !s.items.some(i => i.content && i.content.length > 0))) {
      return true;
    }

    return false;
  }

  onAddNewSectionBtnClick = () => {
    let { customTemplate } = this.state;
    customTemplate.sections.push({
      id: uuidv4(),
      title: 'Untitled checklist',
      items: []
    });

    this.setState({openCustomTemplate: true, customTemplate: customTemplate });
  };

  onEnterItemBtnClick = sectionIndex => {
    let { customTemplate } = this.state;
    customTemplate.sections[sectionIndex].items.push({
      id: uuidv4(),
      content: null
    });

    this.setState({ customTemplate: customTemplate });
  };

  onRemoveItem = (sectionIndex, index) => {
    let { customTemplate } = this.state;

    customTemplate.sections[sectionIndex].items.splice(index, 1);
    this.setState({ customTemplate: customTemplate});
  };

  onRemoveSection = (sectionIndex) => {
    let { customTemplate } = this.state;

    customTemplate.sections.splice(sectionIndex, 1);
    this.setState({ customTemplate: customTemplate});
  };

  onEditTemplateTitle = (value) => {
    let { customTemplate } = this.state;

    this.setState({customTemplate: {...customTemplate, name: value}});
  }

  onEditSectionTitle = (index, value) => {
    let { customTemplate } = this.state;

    customTemplate.sections[index].title = value;
    this.setState({ customTemplate: customTemplate });
  }

  onEditItemContent = (sectionIndex, index, value) => {
    let { customTemplate } = this.state;

    customTemplate.sections[sectionIndex].items[index].content = value;
    this.setState({ customTemplate: customTemplate });
  }

  onEditDisclaimer = (value) => {
    let { customTemplate } = this.state;

    customTemplate.disclaimer = value;
    this.setState({ customTemplate: customTemplate });
  }

  onEditTitleConfig = (field, value) => {
    let { titleConfig } = this.state;
    titleConfig[field].value = value;
    this.setState({ titleConfig: titleConfig });
  }

  onToggleTitleConfig = (field) => {
    let { titleConfig } = this.state;
    titleConfig[field].enabled = !titleConfig[field].enabled;
    if (!titleConfig[field].enabled) {
      titleConfig[field].value = '';
    }
    this.setState({ titleConfig: titleConfig });
  }

  toolTipDisclaimer() {
    return (
      <Tooltip className='in tooltip-siteone' id='disable-go-to'>
        <span>This disclaimer is put right above the signature section in the form.</span>
      </Tooltip>
    );
  }

  renderSections = () => {
    const { customTemplate } = this.state;

    return (
      customTemplate.sections.map((section, index) => {
        return (
          <div key={section.id} className='custom-template-section-item'>
            <div className='top-section'>
              <div className='section-items'>
                <div className='col-xs-11' style={{ top: '5px' }}>
                  <input name={section.id} className='form-control custom-template-name'
                    placeholder='Untitled checklist' autoComplete='off' maxLength='254' value={section.title}
                    onBlur={() => section.title || this.onEditSectionTitle(index, 'Untitled checklist') }
                    onChange={ (e) => this.onEditSectionTitle(index, e.target.value) }/>
                </div>
                <div className='col-xs-1' style={{lineHeight: '46px', textAlign: 'center'}}>
                  <img src={delete_icon} style={{width: 20, cursor: 'pointer'}} onClick={() => this.onRemoveSection(index)}/>
                </div>
              </div>
              { this.renderSectionItems(section, index) }
              <div className='bottom-section'>
                <div className='col-xs-12'>
                  <span onClick={() => this.onEnterItemBtnClick(index)}>Enter item</span>
                </div>
              </div>
            </div>
          </div>
        );
      })
    );
  }

  renderSectionItems = (section, sectionIndex) => {
    if (section.items.length === 0) {
      return '';
    }
    return (
      section.items.map((item, index) => {
        return (
          <div key={item.id} className='bottom-section clearfix'>
            <div style={{ top: 5 }} className='col-xs-1'>
              <span>{index + 1}. </span>
            </div>
            <div style={{ bottom: '10px', right: '10px' }} className='col-xs-9'>
              <div className='item-section-edit'>
                <textarea name={section.id + '|' + item.id} className='form-control' maxLength='254' value={item.content}
                  onChange={ (e) => this.onEditItemContent(sectionIndex, index, e.target.value) }/>
              </div>
            </div>
            <div className='col-xs-2' style={{ lineHeight: '36px' }}>
              <img src={delete_icon} style={{width: 16, cursor: 'pointer'}} onClick={() => this.onRemoveItem(sectionIndex, index)}/>
            </div>
          </div>
        );
      })
    );
  };

  render() {
    const isInvalidTemplate = this.isInvalidTemplate();
    const { openCustomTemplate, customTemplate } = this.state;

    return (
      <Modal scrollable='true' centered='true' dialogClassName='template-eoc-dialog' show={true}>
        <div style={{ margin: 10 }}>
          <Modal.Header>
            <div className='container-fluid'>
              <div className='title-custom-template row'>
                <input
                  name='model'
                  className='form-control'
                  placeholder='Untitled template'
                  autoComplete='off'
                  maxLength='254'
                  value={customTemplate.name}
                  onBlur={() => customTemplate.name || this.onEditTemplateTitle('Untitled template') }
                  onChange={(e) => this.onEditTemplateTitle(e.target.value)}/>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className='container-fluid'>
              <div className='row'>
                <h5 style={{fontWeight: 'bolder', color: 'lightgray', marginLeft: 5}}>Title Configuration</h5>
                <div className='col-xs-12' style={{marginBottom: 10, display: 'flex', alignItems: 'center'}}>
                  <input type='checkbox' checked={this.state.titleConfig.field1.enabled}
                    onChange={() => this.onToggleTitleConfig('field1')} style={{marginRight: 10, width: 18, height: 18, cursor: 'pointer'}} />
                  <input className='form-control' placeholder='Title 1' value={this.state.titleConfig.field1.value}
                    disabled={!this.state.titleConfig.field1.enabled}
                    onChange={(e) => this.onEditTitleConfig('field1', e.target.value)} />
                </div>
                <div className='col-xs-12' style={{marginBottom: 10, display: 'flex', alignItems: 'center'}}>
                  <input type='checkbox' checked={this.state.titleConfig.field2.enabled}
                    onChange={() => this.onToggleTitleConfig('field2')} style={{marginRight: 10, width: 18, height: 18, cursor: 'pointer'}} />
                  <input className='form-control' placeholder='Title 2' value={this.state.titleConfig.field2.value}
                    disabled={!this.state.titleConfig.field2.enabled}
                    onChange={(e) => this.onEditTitleConfig('field2', e.target.value)} />
                </div>
                <div className='col-xs-12' style={{marginBottom: 10, display: 'flex', alignItems: 'center'}}>
                  <input type='checkbox' checked={this.state.titleConfig.field3.enabled}
                    onChange={() => this.onToggleTitleConfig('field3')} style={{marginRight: 10, width: 18, height: 18, cursor: 'pointer'}} />
                  <input className='form-control' placeholder='Title 3' value={this.state.titleConfig.field3.value}
                    disabled={!this.state.titleConfig.field3.enabled}
                    onChange={(e) => this.onEditTitleConfig('field3', e.target.value)} />
                </div>
              </div>
              <br />
              <div className='row'>
                <h5 style={{fontWeight: 'bolder', color: 'lightgray', marginLeft: 5}}>Checklist Configuration</h5>
              </div>
              <div className='row'>
                {openCustomTemplate && this.renderSections()}
              </div>
              <div className='row'>
                <button onClick={this.onAddNewSectionBtnClick} className='btn btn-primary btn-siteone-default' >
                  <span className='fa fa-plus icon' />Add new checklist</button>
              </div>
              <br />
              <div className='row'>
                <h5 style={{fontWeight: 'bolder', color: 'lightgray'}}>Text Configuration</h5>
                <div className='disclaimer'>
                  <span>Disclaimer <OverlayTrigger placement='right' overlay={this.toolTipDisclaimer()} delayHide={10} delayShow={500}><i className='fa fa-question-circle' /></OverlayTrigger></span>
                  <div className='disclaimer-textarea'>
                    <textarea className='form-control' name='disclaimer' ref='disclaimer' value={customTemplate.disclaimer} style={{height: 225}}
                      maxLength='524288' onChange={(e) => this.onEditDisclaimer(e.target.value)} />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className='row'>
              <div className='col-xs-12' style={{ textAlign: 'left'}}>
                <button onClick={this.props.onClose} className='btn btn-primary btn-siteone-default'>Cancel</button>
                <button disabled={isInvalidTemplate} style={{ marginLeft: '20px' }} className='btn btn-primary btn-siteone' onClick={this.createTemplate}>Create</button>
              </div>
            </div>
          </Modal.Footer>
          {
            this.state.openConfirmCancelModal &&
              <ConfirmCancel
                isOpen={this.state.openConfirmCancelModal}
                onOk={this.props.onClose}
                onCancel={this.onCancelConfirmModal}/>
          }
        </div>
      </Modal>
    );
  }
}

export default connect()(TemplateEPLAdd);



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/template-epl-add.js